import { Subject } from 'rxjs';
import { ICampaigner } from '@models/fundraiser.model';
import { DONATION_INFO_TEXT } from '@common-components/donation-confirmation/donation-info';
import { EventsService } from '@services/events/events.service';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VwoService } from '@services/vwo/vwo.service';
import { CurrencyIconPipe } from '@pipes/currency-icon/currency-icon.pipe';
import { UtilPipe } from '@pipes/util-pipe/util-pipe.pipe';
import { ButtonComponent } from '@common-components/button/button.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-donation-confirmation-sheet',
  standalone: true,
  imports: [
    CurrencyIconPipe,
    UtilPipe,
    ButtonComponent,
    MatButtonModule
  ],
  templateUrl: './donation-confirmation-sheet.component.html',
  styleUrls: ['./donation-confirmation-sheet.component.scss']
})
export class DonationConfirmationSheetComponent {

  readonly vars = inject(VariablesService);
  readonly util = inject(UtilService);
  private bottomSheetRef = inject(MatBottomSheetRef<DonationConfirmationSheetComponent>);
  data = inject(MAT_BOTTOM_SHEET_DATA);
  private events = inject(EventsService);
  private dialog = inject(MatDialog);
  private router = inject(Router);
  readonly activatedRoute = inject(ActivatedRoute);
  readonly vwo = inject(VwoService);
  campaigner: ICampaigner;
  cancelPayment = new Subject();
  isStorypage = false;
  miniStory = false;

  info = DONATION_INFO_TEXT;
  beneficiaryName = '';
  isNGO = false;
  isMedical = false;

  ngOnInit() {
    this.campaigner = this.vars.fundraiser.campaigner;
    this.getBeneficiaryName();
    if (this.router.url.match('stories')) {
      this.isStorypage = true;
    }
    if (this.activatedRoute.snapshot.queryParams.mini_story) {
      this.miniStory = true;
    }
  }

  getBeneficiaryName() {
    if (this.vars.beneficiary) {
      this.beneficiaryName = this.vars.beneficiary.full_name;
    } else if (this.vars.fundraiser?.beneficiaryname?.info_1) {
      this.beneficiaryName = this.vars.fundraiser?.beneficiaryname?.info_1;
    } else if (this.vars.fundraiser?.basicinfo) {
      this.beneficiaryName = this.vars.fundraiser.basicinfo.find(item => item.info_type === 'beneficiary_name')?.info_1;
    }
    this.isNGO = this.vars.fundraiser.parent_cause_id === 48;
    this.isMedical = this.vars.ALL_MEDICAL_CAUSES.includes(this.vars.fundraiser?.cause?.id) ? true : false;
  }

  handleCloseAndSendEvent(choice): void {
    const self = this;
    const choices = {
      cancel: () => {
        self.bottomSheetRef.dismiss();
        this.dialog.closeAll();
        this.cancelPayment.next(true);
        return 'cancel_popup';
      },
      closeBtn: () => {
        self.bottomSheetRef.dismiss();
        return 'close_btn_popup';
      },
      help: () => {
        self.bottomSheetRef.dismiss();
        return 'help_popup';
      }
    };

    const info1 = choices[choice]() || '';
    const payload = {
      eventName: 'donation_confirmation',
      event_type: 'campaign',
      page_name: this.vars.pageName || 'home',
      event_type_id: this.vars.fundraiser.id,
      info_1: info1,
      info_2: ''
    };
    this.events.sendSystemEvent(payload).subscribe(_ => _);
  }
}
